module.exports = __webpack_public_path__ + "img/ectivemsp100.0d8a10d4.png";